// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "group_loyalty__desc-rgIs6";
var _3 = "form__field_loyaltyCardHint-1sgyv";
export { _1 as "__esModule", _2 as "group_loyalty__desc", _3 as "form__field_loyaltyCardHint" }
export default { "__esModule": _1, "group_loyalty__desc": _2, "form__field_loyaltyCardHint": _3 }
